import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Header from "../header";
import { apiCall_domain } from "../api";
import axios from "axios";
import Spinner from "../Spinner/Spinner";
import { Pagination } from "@mui/material";
import { Link } from "react-router-dom";

class myOrders extends Component {
  state = {
    currentOrder: { data: [] },
    loading: true,
    archiveOrder: { data: [] },
  };

  async componentDidMount() {
    this.getArchiveOrders();
    this.getCurrentOrders();
  }
  getArchiveOrders = (id = 1) => {
    this.setState({ loading: true }, () => {
      const headers = {
        Authorization: localStorage.getItem("Api_key"),
        "content-type": "application/json",
      };
      axios
        .get(
          `${apiCall_domain}/customer/user/orders?want=items&type=archive&page=${id}`,
          {
            headers: headers,
          },
        )
        .then((res) => {
          this.setState({ archiveOrder: res.data, loading: false });
        });
    });
  };
  getCurrentOrders = (id = 1) => {
    this.setState({ loading: true }, () => {
      const headers = {
        Authorization: localStorage.getItem("Api_key"),
        "content-type": "application/json",
      };
      axios
        .get(
          `${apiCall_domain}/customer/user/orders?want=items&type=current&page=${id}`,
          {
            headers: headers,
          },
        )
        .then((res) => {
          this.setState({ currentOrder: res.data, loading: false });
        });
    });
  };
  detailsOrder = (id) => {
    this.props.history.push({
      pathname: "/orderDetails",
      stateId: id,
    });
  };
  changePage = (e, page, type) => {
    if (type === "archive") {
      this.getArchiveOrders(page);
    } else {
      this.getCurrentOrders(page);
    }
  };
  render() {
    return (
      <>
        <Header
          showSearchBar={true}
          title={"سفارشات من"}
          changeDetail={true}
          backUrl="/profile"
        />
        <div className="allOrders">
          <Tabs>
            <TabList>
              <Tab> خرید های جاری</Tab>
              <Tab>آرشیو خریدها</Tab>
            </TabList>
            <TabPanel>
              <div className={`currentOrder`}>
                {this.state.loading ? (
                  <Spinner />
                ) : this.state.currentOrder.data.length === 0 ? (
                  <div className="noCurrentOrder">
                    لیست خرید های جاری شما خالی است
                  </div>
                ) : (
                  <>
                    {this.state.currentOrder.data.map((item) => (
                      <div
                        className="myCurrentOrder"
                        // onClick={() => this.detailsOrder(item.id)}
                      >
                        <Link to={`/orderDetails/${item.id}`}>
                          <div className="orderType">
                            <span className="orderId">
                              سفارش {item.id} #
                              <span className="type">
                                {item.is_installment === 1 ? (
                                  <>(اقساطی)</>
                                ) : (
                                  <>(عادی)</>
                                )}
                              </span>
                            </span>
                            <div className="typeDetails">
                              {item.status_text}
                            </div>
                          </div>
                          <div className="otherDetails">
                            <div className="date">
                              تاریخ :
                              <span className="dateTime">
                                {item.date} {item.time}
                              </span>
                            </div>
                            <div className="price">
                              قیمت :
                              <span>{item.final_price?.toLocaleString()} </span>
                              تومان
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                    <Pagination
                      count={this.state.currentOrder.meta.last_page}
                      onChange={(e, page) => {
                        this.changePage(e, page, "current");
                      }}
                      page={this.state.currentOrder.meta.current_page}
                    />
                  </>
                )}
              </div>
            </TabPanel>
            <TabPanel>
              <div className="currentOrder">
                {this.state.loading ? (
                  <Spinner />
                ) : this.state.archiveOrder.data.length === 0 ? (
                  <div className="noCurrentOrder">
                    لیست خرید های آرشیو شما خالی است
                  </div>
                ) : (
                  <>
                    {this.state.archiveOrder.data.map((item) => (
                      <div className="myCurrentOrder">
                        <Link to={`/orderDetails/${item.id}`}>
                          <div className="orderType">
                            <span className="orderId">
                              سفارش {item.id} #
                              <span className="type">
                                {item.is_installment === 1 ? (
                                  <>(اقساطی)</>
                                ) : (
                                  <>(عادی)</>
                                )}
                              </span>
                            </span>
                            <div className="typeDetails">
                              {item.status_text}
                            </div>
                          </div>
                          <div className="otherDetails">
                            <div className="date">
                              تاریخ :
                              <span className="dateTime">
                                {item.date} {item.time}
                              </span>
                            </div>
                            <div className="price">
                              قیمت :
                              <span>{item.final_price?.toLocaleString()} </span>
                              تومان
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                    <Pagination
                      count={this.state.archiveOrder.meta.last_page}
                      onChange={(e, page) => {
                        this.changePage(e, page, "archive");
                      }}
                      page={this.state.archiveOrder.meta.current_page}
                    />
                  </>
                )}
              </div>
            </TabPanel>
          </Tabs>
        </div>
      </>
    );
  }
}
export default myOrders;
